import _classCallCheck from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import React from 'react';
import Utils from '../utils/utils';
import Mixins from '../utils/mixins';
import __reactComponentSlots from '../runtime-helpers/react-component-slots.js';
import __reactComponentSetProps from '../runtime-helpers/react-component-set-props.js';

var F7AccordionToggle =
/*#__PURE__*/
function (_React$Component) {
  _inherits(F7AccordionToggle, _React$Component);

  function F7AccordionToggle(props, context) {
    _classCallCheck(this, F7AccordionToggle);

    return _possibleConstructorReturn(this, _getPrototypeOf(F7AccordionToggle).call(this, props, context));
  }

  _createClass(F7AccordionToggle, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var className = props.className,
          id = props.id,
          style = props.style;
      var classes = Utils.classNames(className, 'accordion-item-toggle', Mixins.colorClasses(props));
      return React.createElement('div', {
        id: id,
        style: style,
        className: classes
      }, this.slots['default']);
    }
  }, {
    key: "slots",
    get: function get() {
      return __reactComponentSlots(this.props);
    }
  }]);

  return F7AccordionToggle;
}(React.Component);

__reactComponentSetProps(F7AccordionToggle, Object.assign({
  id: [String, Number],
  className: String,
  style: Object
}, Mixins.colorProps));

F7AccordionToggle.displayName = 'f7-accordion-toggle';
export default F7AccordionToggle;